/**
 * Which edge a bar has fallen off, if any. Pure, so the chip's side is testable — the old
 * version decided this inside an IntersectionObserver callback and expressed the answer by
 * writing `justifySelf` and `flexDirection` onto a DOM node.
 */
export const offscreenSideOf = ({
  barX,
  barWidth,
  scrollLeft,
  viewportWidth,
  sidebarWidth,
}: {
  barX: number;
  barWidth: number;
  scrollLeft: number;
  viewportWidth: number;
  sidebarWidth: number;
}): 'start' | 'end' | null => {
  const timelineWidth = viewportWidth - sidebarWidth;

  if (timelineWidth <= 0) return null;

  if (barX + barWidth <= scrollLeft) return 'start';
  if (barX >= scrollLeft + timelineWidth) return 'end';

  return null;
};
